import CMSApi from '../utils/opsloth_cms_service_api'
import React from 'react'
import AddIcon from '@mui/icons-material/Add'
import { Box, Button, Chip, Dialog, DialogActions, DialogTitle, Fab, TextField } from '@mui/material'
import { Container } from '@mui/system'
import select_items from '../utils/select_items'

type Tags = {
  _id: string,
  tag: string
}

function ProductTags(props: any) {
  let tagTextField = ''
  const brandModal = new CMSApi('product_tags')
  const [tags, setTags] = React.useState<Tags[]>([])
  const [addDialogOpen, setAddDialogOpen] = React.useState(false)
  const getProductTags = async () => {
    const res = await select_items.loadTags()
    setTags(res as Tags[])
  }

  const handleOnTextFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    tagTextField = event.target.value
  }

  const handleAdd = async () => {
    const res: any = await brandModal.post({
      tag: tagTextField.toUpperCase()
    })
    if (res.data._id) {
      props.newAlert('创建标签成功')
      setAddDialogOpen(false)
      getProductTags()
    }
  }

  const handleOnBrandDelete = (_id: string) => async () => {
    const confirm = window.confirm('确认删除该标签？')
    if (confirm) {
      await brandModal
        .setFilter({ _id: _id })
        .put({ deleted: true })
      getProductTags()
    }
  }

  React.useEffect(() => {
    getProductTags()
  }, [])

  return (
    <Box>
      {
        tags.map((item, index) => {
          return <Chip
            key={index}
            sx={{ m: .7, px: 1, fontSize: '1em' }}
            label={item.tag}
            size='medium'
            color='primary'
            onDelete={handleOnBrandDelete(item._id)}
          />
        }
        )
      }
      {
        <Fab
          sx={{ position: 'fixed', right: 20, bottom: 50 }}
          color='primary'
          size='medium'
          onClick={() => { setAddDialogOpen(true) }}
        >
          <AddIcon></AddIcon>
        </Fab >
      }
      <Dialog
        maxWidth='xl'
        open={addDialogOpen}
        onClose={() => { setAddDialogOpen(false); tagTextField = '' }}
      >
        <Container
          maxWidth='xl'
        >
          <DialogTitle>添加标签</DialogTitle>
          <TextField
            onChange={handleOnTextFieldChange}
            sx={{ width: '30em' }}
          ></TextField>
        </Container>
        <DialogActions>
          <Button
            sx={{ m: 1 }}
            onClick={() => setAddDialogOpen(false)}
          >
            {"取消"}
          </Button>

          <Button
            onClick={handleAdd}
          >
            {"提交"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}



export default ProductTags